import { CheckCircle2, Clock, Minus, AlertCircle } from "lucide-react";

export const STATE_BADGES = {
  paid:    { label: "Paga",       cls: "bg-emerald-100 text-emerald-800",   Icon: CheckCircle2 },
  pending: { label: "Pendente",   cls: "bg-amber-50 text-amber-800 border border-amber-200", Icon: Clock },
  exempt:  { label: "Isenta",     cls: "bg-blue-50 text-blue-700",          Icon: Minus },
  no_tier: { label: "Sem nível",  cls: "bg-gray-100 text-gray-600",         Icon: AlertCircle },
};

export const Th = ({ children }) => (
  <th className="text-left text-[11px] uppercase tracking-[0.18em] text-[hsl(var(--muted-foreground))] font-medium px-4 py-3">{children}</th>
);

export function TierInput({ label, tier, value, onChange, testid, hint }) {
  return (
    <div>
      <label className="block text-xs uppercase tracking-[0.18em] text-[hsl(var(--muted-foreground))] mb-2">{label}</label>
      <div className="relative">
        <input
          type="number" min="0" step="1" value={value ?? 0}
          onChange={(e) => onChange(e.target.value)}
          className="w-full bg-white border border-[hsl(var(--border))] px-4 py-3 pr-10 focus:outline-none focus:border-[hsl(var(--accent))]"
          data-testid={`${testid}-input`}
        />
        <span className="absolute right-4 top-1/2 -translate-y-1/2 text-sm text-[hsl(var(--muted-foreground))]">€</span>
      </div>
      {hint && <div className="mt-1 text-[11px] text-[hsl(var(--muted-foreground))]">{hint}</div>}
    </div>
  );
}

const TONE_STYLES = {
  primary: "bg-[hsl(var(--primary))] text-white",
  emerald: "bg-emerald-50 text-emerald-900 border border-emerald-200",
  amber:   "bg-amber-50 text-amber-900 border border-amber-200",
  accent:  "bg-[hsl(var(--accent))] text-[#1A201F]",
};

export function StatCard({ label, value, sub, tone = "primary", testid }) {
  return (
    <div className={`p-6 ${TONE_STYLES[tone]}`} data-testid={testid}>
      <div className="text-[11px] uppercase tracking-[0.2em] opacity-80">{label}</div>
      <div className="display-heading text-3xl sm:text-4xl mt-3">{value}</div>
      <div className="mt-3 text-xs opacity-80">{sub}</div>
    </div>
  );
}

export function ProgressBar({ pct }) {
  const p = Math.max(0, Math.min(100, pct || 0));
  return (
    <div className="mt-1 w-full h-1.5 bg-black/15 rounded-sm overflow-hidden">
      <div className="h-full bg-[#1A201F]/70" style={{ width: `${p}%` }} />
    </div>
  );
}
